import { createStyles, makeStyles } from "@material-ui/core/styles";
import {
  Autocomplete,
  Box,
  Chip,
  ClickAwayListener,
  Popper,
  TextField,
} from "@mui/material";
import { ReactComponent as BlueArrowUp } from "assets/icons/BlueArrowUp.svg";
import { ReactComponent as GrayArrowDown } from "assets/icons/GrayArrowDown.svg";
import { ReactComponent as RemoveTagIcon } from "assets/icons/RemoveTagIcon.svg";
import React, { useEffect, useState } from "react";
import { BeatLoader } from "react-spinners";
import {
  ArrowWrapper,
  Button,
  Buttons,
  Label,
  ListItem,
  NumberOfItems,
} from "./Theme";
import "./index.scss";

export const MultiSelect = ({
  placeholder,
  label,
  isOptinal,
  isCheckBoxOption,
  options,
  loading,
  total,
  formik,
  searchAction,
  formikField,
  variableForSave,
  handleFormikChange,
  isAccount,
  formikKey,
  isMultiple,
  styleLabel,
  isAll,
  width = "312px",
  popperClassName = "",
}) => {
  const key = isAccount ? "account" : "people";
  const formikData =
    formik.values[key][formikKey]?.[0] === "-1"
      ? options
      : formik.values[key][formikKey];
  const isAllSelected = formik.values[key][formikKey]?.[0] === "-1";
  const values = formikData !== undefined ? formikData : [];
  const [value, setValue] = useState(values);
  const [checkAll, setCheckAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const removeItemFromFormik = () => {
    const updatedObject = { ...formik.values[key] };
    delete updatedObject[formikKey];
    formik.setFieldValue(key, updatedObject);
  };

  useEffect(() => {
    setValue(formikData !== undefined ? formikData : []);
  }, [formikData]);

  const checkAllChange = (event) => {
    setCheckAll(true);
    setValue(options);
    handleFormikChange(["-1"], formikField);
  };
  const clearAllChange = (event) => {
    setCheckAll(false);
    setValue([]);
    setInputValue("");
    formik.setFieldValue("clear", false);
    removeItemFromFormik();
  };

  const handleClickAway = (e) => {
    setOpen(false);
  };
  const toggleOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen((isOpen) => !isOpen);
  };
  const handleOnChange = (newValue, reason) => {
    if (reason === "selectOption") {
      !isCheckBoxOption && setOpen(false);
      // setInputValue("");
      setValue(newValue);
      handleFormikChange(newValue, formikField, variableForSave);
    } else if (reason === "removeOption") {
      setCheckAll(false);
      setValue(newValue);
      if (newValue?.length === 0) {
        removeItemFromFormik();
      } else {
        handleFormikChange(newValue, formikField, variableForSave);
      }
    } else if (reason === "clear") {
      setValue([]);
      setCheckAll(false);
      removeItemFromFormik();
    }
  };
  const useStyles = makeStyles((theme) =>
    createStyles({
      root: {
        boxShadow: "none",
        marginTop: "10px",
        zIndex: 9999,
        "& .MuiAutocomplete-listbox": {
          borderRadius: "0",
        },
        "& .MuiPaper-elevation1": {
          boxShadow: "none !important",
          borderRadius: "none !important",
        },
      },
      customChip: {
        width: "auto",
        maxWidth: "10rem",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "inline-flex",
        "& .MuiChip-deleteIcon": {
          width: 8,
          height: 8,
          fontSize: 8,
          margin: "0 6px 0 0",
          color: "var(--Blue-20, #EAEEFC)",
          "&:hover": {
            color: "var(--Blue-20, #EAEEFC)",
          },
          "& svg": {
            width: 8,
            height: 8,
            display: "block",
          },
        },
        "& .MuiChip-label": {
          color: "var(--Blue-100, #2555EF)",
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 400,
        },
        "& .MuiAutocomplete-listbox": {
          "& li:nth-child(even)": { backgroundColor: "#CCC" },
          "& li:nth-child(odd)": { backgroundColor: "#FFF" },
        },
      },
    })
  );

  const classes = useStyles();
  useEffect(() => {
    if (formik.values?.clear) {
      setValue([]);
      setInputValue("");
    }
  }, [formik.values]);
  useEffect(() => {
    console.log('isAll', isAll)
    if (isAll) checkAllChange();
  }, []);

  const findSelectedValue = () => {
    return options.filter((option) => values.find((val) => val.id === option.id));
  }



  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box   className="main__multi-select" sx={{ maxWidth: width }}>
        {label && (
          <Label style={styleLabel}>
            <span>{label}</span>
            {isOptinal && <span>{`(optional)`}</span>}
          </Label>
        )}
        {isCheckBoxOption ? (
          <Autocomplete
            multiple
            disableCloseOnSelect={true}
            disableClearable
            limitTags={0}
            id="asynchronous-demo"
            options={options}
            value={findSelectedValue()}
            inputValue={checkAll && isAllSelected ? "" : inputValue}
            open={open}
            loading={loading}
            onChange={(event, newValue, reason) => {
              if (reason === "removeOption" || (!checkAll && !isAllSelected)) {
                handleOnChange(newValue, reason);
              }
            }}
            onClose={(e, reason) => {
              if (reason === "escape") {
                setOpen(false);
              }
            }}
            sx={{
              border:
                values?.length > 0
                  ? "1px solid var(--blues-blue-3, #99B7EF)"
                  : "1px solid var(--Gray-40, #E1E1E7)",
              background:
                values?.length > 0
                  ? "var(--Blue-10, #F3F6F9)"
                  : "var(--White-100, #FFF)",
              maxWidth: width,
              maxHeight: "48px !important",
              borderRadius: "5px",
              "& .MuiMenu-paper": {
                marginTop: "50px !important", // Adjust the margin as needed
                zIndex: "1000",
              },
              "&.MuiFormControl-fullWidth": {
                borderRadius: "5px",
                border: "1.5px solid #03b2cb",
              },
              "&:hover": {
                border: "1px solid #cccccc",
              },
              "&& fieldset": {
                width: "100%",
                justifyContent: "center",
                border: "0",
                background: "var(--Blue-10, #F3F6F9) !importent",
              },
            }}
            onOpen={() => {
              setOpen(true);
            }}
            PopperComponent={(param) => (
              <Popper {...param} className={`${classes.root} ${popperClassName}`.trim()}>
                <Box
                  sx={{
                    borderTopRightRadius: "5px",
                    borderTopLeftRadius: "5px",
                    borderTop: "1px solid var(--Dark-Blue-10, #E6EAEF)",
                    background: "var(--White-100, #FFF)",
                    boxShadow: "0px 17px 20px 0px rgba(19, 30, 68, 0.08)",
                    marginTop: "8px",
                    backgroundColor: "white",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {!inputValue && (
                    <Buttons>
                      <Button
                        onClick={checkAllChange}
                        id="check-all"
                        sx={{ marginRight: "8px" }}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        SELECT ALL
                      </Button>
                      <Button
                        onClick={clearAllChange}
                        id="check-all"
                        sx={{ marginRight: "8px" }}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        CLEAR
                      </Button>
                    </Buttons>
                  )}
                </Box>

                <div
                  {...param}
                  sx={{
                    boxShadow: "none",
                  }}
                />
              </Popper>
            )}
            getOptionLabel={(option) => option.title}
            renderOption={(props, option, { selected }) => (
              <ListItem {...props} isCheckBoxOption={isCheckBoxOption}>
                <label className="check-box-container">
                  <input
                    type="checkbox"
                    style={{ marginRight: 8 }}
                    checked={selected || checkAll || (value?.length > 0 && value?.filter((val) => val.id === option.id)?.length > 0)}
                  />
                  <span
                    className={
                      checkAll ? "checkbox-checkmark-all" : "checkbox-checkmark"
                    }
                  ></span>
                </label>
                <span style={{ marginTop: "-10px" }}>{option.title}</span>
              </ListItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={values?.length === 0 && placeholder}
                onChange={(e) => {
                  if (!checkAll) {
                    setInputValue(e.target.value);
                    searchAction({ value: e.target.value, type: formikKey });
                  }
                }}
                sx={{
                  input: {
                    color: "black",
                    "&::placeholder": {
                      color: "var(--Dark-Blue-40, #99ABBE)",
                      fontsize: "14px",
                      fontweight: "400",
                    },
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <BeatLoader color="#2555EF" size={6} margin={1} />
                      ) : null}
                      <ArrowWrapper onMouseDown={toggleOpen}>
                        {open || value?.length > 0 ? (
                          <BlueArrowUp />
                        ) : (
                          <GrayArrowDown />
                        )}
                      </ArrowWrapper>
                    </React.Fragment>
                  ),
                  style: {
                    color: "#2555EF",
                  },
                }}
              />
            )}
            renderTags={(value, getTagProps) => (
              <>
                <Chip
                  label={value[0].title}
                  {...getTagProps(0)}
                  deleteIcon={<RemoveTagIcon />}
                  className={classes.customChip}
                />
                {(isAllSelected ? total : value?.length) > 1 && (
                  <NumberOfItems>{`+${
                    (isAllSelected ? total : value.length) - 1
                  }`}</NumberOfItems>
                )}
              </>
            )}
          />
        ) : (
          <Autocomplete
            id="asynchronous-demo"
            options={options}
            loading={loading}
            onChange={(event, newValue, reason) => {
              handleOnChange(newValue, reason);
            }}
            sx={{
              border:
                values?.length > 0
                  ? "1px solid var(--blues-blue-3, #99B7EF)"
                  : "1px solid var(--Gray-40, #E1E1E7)",
              background:
                values?.length > 0
                  ? "var(--Blue-10, #F3F6F9)"
                  : "var(--White-100, #FFF)",
              maxWidth: width,
              maxHeight: "48px !important",
              borderRadius: "5px",
              "& .MuiMenu-paper": {
                marginTop: "50px !important", // Adjust the margin as needed
                zIndex: "1000",
              },
              "&.MuiFormControl-fullWidth": {
                borderRadius: "5px",
                border: "1.5px solid #03b2cb",
              },
              "&:hover": {
                border: "1px solid #cccccc",
              },
              "&& fieldset": {
                width: "100%",
                justifyContent: "center",
                border: "0",
                background: "var(--Blue-10, #F3F6F9) !importent",
              },
              
            }}
            getOptionLabel={(option) => option.title}
            renderOption={(props, option, { selected }) => (
              <ListItem {...props} isCheckBoxOption={isCheckBoxOption}>
                <span style={{ marginTop: "-10px" }}>{option.title}</span>
              </ListItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={values?.length === 0 && placeholder}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  searchAction({ value: e.target.value, type: formikKey });
                }}
                sx={{
                  input: {
                    color: "var(--Dark-Blue-40, #99ABBE)",
                    "&::placeholder": {
                      color: "var(--Dark-Blue-40, #99ABBE)",
                      fontsize: "14px",
                      fontweight: "400",
                    },
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <BeatLoader color="#2555EF" size={6} margin={1} />
                      ) : null}
                      <ArrowWrapper onMouseDown={toggleOpen}>
                        {open || value?.length > 0 ? (
                          <BlueArrowUp />
                        ) : (
                          <GrayArrowDown />
                        )}
                      </ArrowWrapper>
                    </React.Fragment>
                  ),
                  style: {
                    color: "#2555EF",
                  },
                }}
              />
            )}
          />
        )}
      </Box>
    </ClickAwayListener>
  );
};
